module.exports = __webpack_public_path__ + "static/media/Vote_for_climate_01.5c825a9b.jpg";